import { render, staticRenderFns } from "./drawerStudent.vue?vue&type=template&id=bbcb4016&scoped=true"
import script from "./drawerStudent.vue?vue&type=script&lang=js"
export * from "./drawerStudent.vue?vue&type=script&lang=js"
import style0 from "./drawerStudent.vue?vue&type=style&index=0&id=bbcb4016&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcb4016",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbcb4016')) {
      api.createRecord('bbcb4016', component.options)
    } else {
      api.reload('bbcb4016', component.options)
    }
    module.hot.accept("./drawerStudent.vue?vue&type=template&id=bbcb4016&scoped=true", function () {
      api.rerender('bbcb4016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantAccount/detail-pane/drawerStudent.vue"
export default component.exports